import AssetService from '../../../../shared/services/AssetService';
import { ColumnAsset } from '../../../models/LessonComponentContent';
import DefaultImage from '../../../images/default-image.jpg';
import { IconShape } from '../../../models/LessonComponentSettings';
import React from 'react';
import styles from '../../../styles/Gallery.module.css';

interface IGalleryImageProps {
  item: ColumnAsset;
  shape: IconShape;
}
export const GalleryImage = (props: IGalleryImageProps) => {
  return (
    <img
      className={`${styles.image} ${
        props.shape === 'circle' ? styles.circularShape : styles.squareShape
      }`}
      src={AssetService.getAssetUrl(props.item?.assetkey) || DefaultImage}
    />
  );
};
